/*! @azure/msal-common v14.6.1 2024-01-23 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.6.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
